import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import { Breadcrumb, Row, Col, Image, Form } from "react-bootstrap";
import Footer from "../Footer/Footer";
import * as Icon from "react-feather";
import firebase from "../../Utils/Firebase";
import { Button, Modal } from "react-bootstrap";

class Dashboard extends React.Component {
  state = {
    sideMenu: true,
    directAdvice: "",
    filename: "No PDF Attached",
    file: null,
    showDelete: false,
    advice: [],
    adviceNames: [],
    groups: [],
    group: "",
    modalShow: false,
    barbershopsCount: 0,
    customersCount: 0,
  };

  componentDidMount() {
    let App = this;
    firebase
      .firestore()
      .collection("config")
      .doc("advice")
      .get()
      .then((snapshot) => {
        let data = snapshot.data();
        if (data) {
          if (data.advice) {
            App.setState({ advice: data.advice });
          }
          if (data.names) {
            App.setState({ adviceNames: data.names });
          }
          if (data.groups) {
            App.setState({ groups: data.groups });
          }
        }
      });

    firebase
      .firestore()
      .collection("config")
      .doc("terms")
      .get()
      .then((snapshot) => {
        let data = snapshot.data();
        if (data) {
          let terms = data.terms;
          App.setState({ music: terms });
        }
      });

    firebase
      .firestore()
      .collection("salons")
      .get()
      .then((res) => {
        this.setState({ barbershopsCount: res.docs.length });
      });

    firebase
      .firestore()
      .collection("customers")
      .get()
      .then((res) => {
        this.setState({ customersCount: res.docs.length });
      });
  }

  delete(item, name, index) {
    var tempAdvice = [...this.state.advice];
    tempAdvice.splice(index, 1);
    var tempNames = [...this.state.adviceNames];
    tempNames.splice(index, 1);
    var tempGroups = [...this.state.groups];
    tempGroups.splice(index, 1);
    let App = this;
    firebase
      .firestore()
      .collection("config")
      .doc("advice")
      .update({
        advice: tempAdvice,
        names: tempNames,
        groups: tempGroups,
      })
      .then((result) => {
        window.location.reload();
      });
  }

  inputChanged(value) {
    this.setState({
      filename: document.getElementById("inputGroupFile01").files[0].name,
      file: document.getElementById("inputGroupFile01").files[0],
      showDelete: true,
    });
  }

  removeAttachment() {
    document.getElementById("inputGroupFile01").value = "";
    this.setState({
      filename: "No File Attached",
      file: null,
      showDelete: false,
    });
  }

  async updateMusic() {
    await firebase
      .firestore()
      .collection("config")
      .doc("terms")
      .update({ terms: this.state.music })
      .then((result) => {
        alert("successful!");
        window.location.reload();
      });
  }

  savePDFToFirebase() {
    let app = this;
    let ref = firebase.storage();
    let uid = Math.random()
      .toString(36)
      .substring(7);
    ref = ref.ref().child("direct_advice/" + app.state.filename + ".m3u");
    var uploadTask = ref.put(app.state.file);

    uploadTask.on(
      "state_changed",
      function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      function(error) {
        console.log(error);
      },
      function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log("File available at", downloadURL);

          var tempGroups = app.state.groups;
          tempGroups.push(app.state.group);

          var tempNames = app.state.adviceNames;
          tempNames.push(app.state.filename);

          var tempAdvice = app.state.advice;
          tempAdvice.push(downloadURL);
          firebase
            .firestore()
            .collection("config")
            .doc("advice")
            .update({
              advice: tempAdvice,
              names: tempNames,
              groups: tempGroups,
            })
            .then((result) => {
              window.location.reload();
            });
        });
      }
    );
  }

  render() {
    return (
      <div className="page-wrapper">
        <Navigation onClick={this._onSideMenu} />
        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Dashboard</h1>
              <Breadcrumb.Item to="/dashboard">Dashboard</Breadcrumb.Item>
              <Breadcrumb.Item active>Dashboard v.1</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Row>
            <Col lg="3">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Music Copyright:</h5>
                      <textarea
                        value={this.state.music}
                        onChange={(event) =>
                          this.setState({ music: event.target.value })
                        }
                        style={{ width: "100%" }}
                      />
                    </div>

                    <Button
                      onClick={() => this.updateMusic()}
                      style={{
                        marginTop: 32,

                        marginBottom: 16,
                        width: 200,
                        borderStyle: "none",
                        borderRadius: 10,
                        backgroundColor: "green",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="3">
              <div className="profile-left-content">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="card-header">
                      <h5 className="card-title">Analytics:</h5>
                    </div>
                    <p>
                      Total number of barbershops: {this.state.barbershopsCount}
                    </p>
                    <p>
                      Total number of customers: {this.state.customersCount}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Col lg="6">
            <Button
              variant="primary"
              onClick={() => this.setState({ modalShow: true })}
            >
              Send Push Notification
            </Button>
            <NotificationModal
              show={this.state.modalShow}
              onHide={() => this.setState({ modalShow: false })}
            />
          </Col>

          <Col lg="6">
            <div className="profile-middle-content mb-4">
              <div className="card mb-4">
                <div className="card-body">
                  <div className="card-header">
                    <h5 className="card-title">Direct Advice</h5>
                  </div>

                  <Row
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Form.Group>
                      <Form.Label>PDF ONLY</Form.Label>
                      <div
                        style={{
                          width: 250,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className="input-group"
                      >
                        <div className="custom-file">
                          <input
                            type="file"
                            onChange={(value) => this.inputChanged(value)}
                            className="custom-file-input"
                            id="inputGroupFile01"
                            aria-describedby="inputGroupFileAddon01"
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            {this.state.filename}
                          </label>
                        </div>

                        <div
                          onClick={() => this.removeAttachment()}
                          style={{
                            opacity: this.state.showDelete ? 1 : 0,
                            marginLeft: 16,
                            backgroundColor: "lightgrey",
                            width: 20,
                            height: 20,
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 10,
                          }}
                        >
                          X
                        </div>
                      </div>
                    </Form.Group>
                    <input
                      type="text"
                      placeholder="group"
                      onChange={(event) =>
                        this.setState({ group: event.target.value })
                      }
                    />
                  </Row>
                  <Col>
                    {this.state.advice.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          marginTop: 16,
                          width: 300,
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: 10,
                          padding: 16,
                        }}
                      >
                        <label>
                          {item
                            .split(
                              "https://firebasestorage.googleapis.com/v0/b/trim-direct.appspot.com/o/direct_advice%2F"
                            )[1]
                            .split(".pdf")[0] + ".pdf"}
                        </label>
                        <button
                          style={{ width: 100, marginLeft: 16 }}
                          onClick={() =>
                            this.delete(
                              item,
                              this.state.adviceNames[index],
                              index
                            )
                          }
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </Col>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => this.savePDFToFirebase()}
                    style={{
                      marginBottom: 16,
                      width: 200,
                      borderStyle: "none",
                      borderRadius: 10,
                      backgroundColor: "green",
                      color: "white",
                    }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </Col>

          <div className="flex-grow-1" />
          <Footer />
        </div>
      </div>
    );
  }
}

function NotificationModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Send Notification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input type="text" placeholder="Title" id="notificationTitle" />
        <br />
        <input type="text" placeholder="Body" id="notificationBody" />
        <br />
        <select id="dropDown">
          <option
            id="directAdviceNotifications"
            value="directAdviceNotifications"
          >
            Direct Advice Notifications
          </option>
          <option id="referralNotifications" value="referralNotifications">
            Referral Notifications
          </option>
          <option
            id="barbershopListingNotifications"
            value="barbershopListingNotifications"
          >
            Barbershop Listing Notifications
          </option>
        </select>

        <br />
        <br />
        <Button onClick={() => sendNotificationToCustomers()}>
          Send To Customers
        </Button>
        <Button
          style={{ marginLeft: 16 }}
          onClick={() => sendNotificationToBarbershops()}
        >
          Send To Barbershops
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function sendNotificationToBarbershops() {
  let title = document.getElementById("notificationTitle").value;
  let body = document.getElementById("notificationBody").value;
  var sender = firebase.functions().httpsCallable("sendNotificationToSalons");
  let data = { title, body };

  let dropDown = document.getElementById("dropDown").value;
  data.type = dropDown;
  sender(data)
    .then((result) => {
      alert("The notification was sent successfully");
    })
    .catch((error) => {
      console.log(error);
      alert("There was an error sending your notification");
    });
}

function sendNotificationToCustomers() {
  let title = document.getElementById("notificationTitle").value;
  let body = document.getElementById("notificationBody").value;

  var sender = firebase
    .functions()
    .httpsCallable("sendNotificationToCustomers");

  let data = { title, body };
  let dropDown = document.getElementById("dropDown").value;
  data.type = dropDown;

  sender(data)
    .then((result) => {
      alert("The notification was sent successfully");
    })
    .catch((error) => {
      console.log(error);
      alert("There was an error sending your notification");
    });
}

export default Dashboard;
